import { useEffect } from "react";
import { useToasts } from "react-toast-notifications";
import { getUserFirstName, getUserLastName } from "../selectors/identity";
import { JUST_LOGGED_IN_KEY } from "../lib/auth";

export function useLoginToast() {
  const { addToast } = useToasts();
  useEffect(() => {
    if (localStorage.getItem(JUST_LOGGED_IN_KEY)) {
      localStorage.removeItem(JUST_LOGGED_IN_KEY);
      const fullName = `${getUserFirstName() ?? ""} ${getUserLastName() ?? ""}`.trim();
      if (!fullName) return;
      setTimeout(() => {
        addToast(`Signed in as ${fullName}`, { appearance: "success", autoDismiss: true });
      }, 500);
    }
  }, [window.location.pathname]);
}
